import { render, staticRenderFns } from "./OutputTargetForm.vue?vue&type=template&id=2ef2dd42"
import script from "./OutputTargetForm.vue?vue&type=script&lang=js"
export * from "./OutputTargetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports